import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as InstagramIcon } from "./icons/instagram.svg";
import { ReactComponent as LinkedInIcon } from "./icons/linkedin.svg";
import { ReactComponent as FacebookIcon } from "./icons/facebook.svg";
import { ReactComponent as TwitterXIcon } from "./icons/twitter-x.svg";
import { ReactComponent as SearchIcon } from "./icons/search.svg";
import { ReactComponent as MenuIcon } from "./icons/menu.svg";
import OffcanvasSearch from "./OffcanvasSearch";
import { useTranslation } from "react-i18next";

const NavbarComponent = () => {
  const { t } = useTranslation();

  // Close navbar collapse on load for mobile
	useEffect(() => {
	  const navbarCollapse = document.getElementById("navbar");

	  // Close collapse when clicking a nav-link on mobile
	  const handleNavLinkClick = () => {
		if (window.innerWidth < 992 && window.bootstrap && navbarCollapse?.classList.contains("show")) {
		  const bsCollapse = window.bootstrap.Collapse.getInstance(navbarCollapse);
		  bsCollapse?.hide();
		}
	  };

	  const links = navbarCollapse?.querySelectorAll(".nav-link") || [];
	  links.forEach(link => link.addEventListener("click", handleNavLinkClick));

	  return () => {
		links.forEach(link => link.removeEventListener("click", handleNavLinkClick));
	  };
	}, []);


  return (
    <>
      <OffcanvasSearch />

      <nav id="mainNav" className="navbar navbar-expand-lg navbar-sticky navbar-light bg-white">
        <div className="container">
          <a href="/" className="navbar-brand">
            <img
              src="/logo/logo-dark.svg"
              alt="Logo Alberto Lussana"
              height="100"
            />
          </a>

          {/* Secondary Nav Icons */}
          <ul className="navbar-nav navbar-nav-secondary order-lg-3">
            <li className="nav-item">
              <a
                href="#"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasSearch"
                aria-controls="offcanvasSearch"
                className="nav-link"
              >
                <SearchIcon width={24} height={24} />
              </a>
            </li>

            <li className="nav-item d-lg-none">
              <a
                className="nav-link"
                href="#"
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbar"
                aria-controls="navbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <MenuIcon width={24} height={24} />
              </a>
            </li>
          </ul>

          {/* Desktop Social Links */}
          <ul className="navbar-nav navbar-nav-secondary order-lg-3 d-none d-lg-flex">
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.instagram.com/albertolussana/"
                target="_blank"
                rel="noreferrer"
              >
                <InstagramIcon width={24} height={24} />
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.linkedin.com/in/albertolussana/"
                target="_blank"
                rel="noreferrer"
              >
                <LinkedInIcon width={24} height={24} />
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://www.facebook.com/albertolussana"
                target="_blank"
                rel="noreferrer"
              >
                <FacebookIcon width={24} height={24} />
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://twitter.com/albertolussana"
                target="_blank"
                rel="noreferrer"
              >
                <TwitterXIcon width={24} height={24} />
              </a>
            </li>
          </ul>

          {/* Primary Nav */}
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link" to="/photos">
                  {t("nav.photos", "Photos")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/kitchen">
                  {t("nav.kitchen", "Recipes")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about-me">
                  {t("nav.aboutMe", "About me")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/officina">
                  {t("nav.officina", "Officina")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/newsletter">
                  {t("nav.newsletter", "Newlstter")}
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contacts">
                  {t("nav.contacts", "Contacts")}
                </Link>
              </li>

              {/* Mobile Social Links */}
              <li className="nav-item d-lg-none">
                <ul className="nav nav-gap-sm nav-social align-items-center list-inline">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://www.instagram.com/albertolussana/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <InstagramIcon width={24} height={24} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://www.linkedin.com/in/albertolussana/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <LinkedInIcon width={24} height={24} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://www.facebook.com/albertolussana"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FacebookIcon width={24} height={24} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://twitter.com/albertolussana"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <TwitterXIcon width={24} height={24} />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavbarComponent;
